import { BREAK_ } from 'constants';
import styled, { css, keyframes } from 'styled-components'

const pulseAnimation = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.4);
  }
  100% {
    transform: scale(1);
  }
`;

export const Svg = styled.svg`
  width: 50px;
  height: 50px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  overflow: visible;
  pointer-events:none;
  z-index: 10; // Set highest z-index for Svg

  ${BREAK_.md_dn} {
      width: 30px;
      height: 30px;
  }
`
export const Circle = styled.circle`
  fill: ${({ clr }) => clr.primary_text};
  animation: ${pulseAnimation} 1s infinite;
  transform-origin: center;
`
export const CircleGroup = styled.g`
&:hover {
  animation: ${pulseAnimation} 1s infinite;
}
`

export const Line = styled.line`
  stroke:#fff;
  stroke-width:3;
`

export const Pos = styled.div(({ c }) => css`
  pointer-events: none;
  position: absolute;
  left: ${c?.[0]}px;
  top: ${c?.[1]}px;
  width: 0px;
  height: 0px;
`)

export const LabContainer = styled.div(({ d, l }) => css`
  background: ${({ clr }) => `${clr.primary}e6`};

  position: absolute;
  left: ${l}px;
  top: 0;

  transform-origin: center;
  transform: translate(-50%, -50%) rotate(-${d}deg);  // ✅ clean cancel

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  border: 2px solid #fff;
  border-radius: 8px;

  pointer-events: none;
  z-index: 5;

  ${BREAK_.md_dn} {
    pointer-events: auto;
  }
`)

export const Lab = styled.div`
  color: #000;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 5px;
  flex-direction: column;
  cursor:pointer;
  pointer-events:none;
  border-radius:8px;
  ${ BREAK_.md_dn } {
    padding: 8px 16px;
    background: ${({ clr }) => `${clr.primary}e6`};
    // transform: ${`rotate(-${d}deg) translate(-50%,-50%)`};
    transform-origin: left top;
    top: 0;
    pointer-events: auto;
  }
`

export const Outer = styled.div(({ d, xAxis, yAxis }) => css`
  top: ${yAxis}px;
  left: ${xAxis}px;
  position: absolute;

  transform-origin: center;
  transform: rotate(${d}deg);   // ✅ ONLY rotate

  pointer-events: none;
  background: transparent;
  z-index: 10;

  ${BREAK_.md_dn} {
    pointer-events: auto;
  }
`)

export const Text1 = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  white-space:nowrap;
  font-size: 16px;
  ${ BREAK_.md_dn } {
    font-size: 12px;
  }
  font-weight: 600;
  letter-spacing:0.25px;
  color: #fff;
  pointer-events:none;
`
export const Text2 = styled.div`
width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  white-space:nowrap;
  font-size: 14px;
  ${ BREAK_.md_dn } {
    ffont-size: 12px;
  }
  font-weight: 400;
  letter-spacing:0.5px;
  color: #fff;
  pointer-events:none;
  // padding: 1rem;
`